import Vue from 'vue'
import 'highlight.js/styles/default.min.css'
import Highlight from 'vue-markdown-highlight'

Vue.use(Highlight)
